import {
  FieldLinkRefKind,
  getFieldLinkOption,
  getRefKind,
} from 'app/pages/system/checklists/ChecklistForms/FieldLinkPicker/FieldLinkPicker.utils';

/**
 * Resolves a checklist item's stored `fieldRef` to a human-readable label for the
 * "Suppressed fields" list — the SAME appFormsTree catalog the "Needed" indicators
 * and Part One's "Go to field" navigation resolve against.
 *
 * A `fieldRef` is either a FIELD path (`section-subsection-tab-form-leaf`) resolved
 * via `appFormsTreeFieldOptionsMapExtended`, or a prefixed SECTION/area ref
 * (`section:`/`subsection:`/`tab:`/`page:`) resolved via `sectionLinkOptionsMap`.
 *
 * @param {string} fieldRef
 * @returns {{ label: string, context: (string|null) }} label = the field/section
 *   name; context = a breadcrumb (`section / tab`) or null.
 */
export const resolveFieldLinkLabel = fieldRef => {
  if (!fieldRef) {
    return { label: '', context: null };
  }

  const fieldOption = getFieldLinkOption(fieldRef);

  if (getRefKind(fieldRef) === FieldLinkRefKind.SECTION) {
    return { label: fieldOption?.name ?? fieldRef, context: null };
  }

  if (!fieldOption) {
    return { label: fieldRef, context: null };
  }

  const context = [fieldOption.sectionLabel, fieldOption.tabLabel].filter(Boolean).join(' / ');

  return { label: fieldOption.name, context: context || null };
};
